export default __webpack_public_path__ + "media/images/avatars/avatar8-8e436089818c187586dd04edb31c4804.png";